export const getPostFormat = (types, current) => {
	for (const postType in types)
		if (types[postType].id === current || postType === current) return types[postType].value;
};

export function convertTime(timeStr) {
	if (timeStr.includes("T")) return timeStr.split("T")[0];
	if (timeStr.includes(" ")) return timeStr.split(" ")[0];
}

export function decodeHtml(html) {
	const txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}
